export const getVideoLocale = (languages, offset) => {
    let data = Object.values(languages).filter((tmp)=>{return tmp.locale === offset});
    
    if(data.length > 0){
        return data[0].videolocale;
    }
    else{
        return 'en_EN';
    }
}